// components/Admin/UncheckedDeliverablesCard.jsx
import React from 'react';
import '../../styles/UncheckedDeliverablesCard.css';

const UncheckedDeliverablesCard = ({ alerts }) => {
  if (!alerts || alerts.length === 0) return null;

  return (
    <div className="unchecked-card">
      <h3>未確認の提出物</h3>
      <ul>
        {alerts.map((msg, i) => (
          <li key={i}>{msg}</li>
        ))}
      </ul>
    </div>
  );
};

export default UncheckedDeliverablesCard;
